var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplaceMenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_321_8218)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7939 9.80351C13.7939 9.80351 14.1128 4.05335 18.995 3.935C23.8805 3.81993 24.1665 9.77392 24.1665 9.77392L20.8427 9.80351C20.8427 9.80351 20.435 5.90103 19.281 5.75637C18.1271 5.61172 17.2032 9.68516 17.2032 9.68516L13.7939 9.80022V9.80351Z",
    fill: "url(#paint0_linear_321_8218)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70605 13.2423C4.57509 18.2231 3.96358 24.9497 3.49015 32.1464C3.34221 34.3821 4.9729 36.3481 7.19866 36.6013C14.1653 37.3936 22.8217 37.0813 32.1062 36.3613C34.5226 36.1739 36.2881 33.9908 35.9527 31.5908C34.9401 24.3645 33.7631 17.7299 32.1653 12.5749C31.6853 11.0296 30.3735 9.89539 28.7724 9.65539C23.2853 8.83018 16.539 9.20827 9.34552 10.017C7.57017 10.2176 6.10057 11.5031 5.70276 13.2455L5.70605 13.2423Z",
    fill: "url(#paint1_linear_321_8218)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9556 31.5913C35.1962 26.1567 34.3381 21.0575 33.2827 16.6685C33.2334 17.109 33.1742 17.5496 33.1019 17.9868C32.4279 22.0471 30.6362 26.0712 27.4175 28.6356C23.4263 31.8115 17.8997 32.2817 12.8301 31.6997C10.2065 31.4006 7.58948 30.8548 4.94947 30.9732C4.4892 30.9929 4.02563 31.0389 3.56536 31.1113C3.54234 31.4565 3.51933 31.8017 3.49632 32.1469C3.34837 34.3825 4.97906 36.3485 7.20482 36.6017C14.1714 37.394 22.8279 37.0817 32.1123 36.3617C34.5288 36.1743 36.2943 33.9913 35.9589 31.5913H35.9556Z",
    fill: "#185C00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72631 10.5463C4.21015 12.0685 3.89782 13.8406 3.71371 15.7737C3.32247 19.8801 6.04139 23.6806 10.0589 24.6176C15.6907 25.9294 21.556 25.8275 27.6086 24.5551C32.2377 23.5853 35.1966 18.9727 34.0262 14.3896C33.6382 12.8773 33.1648 11.3913 32.6026 9.9381C32.2442 9.01427 31.3796 8.38632 30.3933 8.29755C22.9401 7.617 15.0694 7.86029 6.88961 8.79728C5.89015 8.91235 5.04522 9.5929 4.72302 10.5463H4.72631Z",
    fill: "url(#paint2_linear_321_8218)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6121 24.5555C32.2412 23.5856 35.2001 18.973 34.0297 14.39C33.6417 12.8776 33.1683 11.3916 32.6061 9.93845C32.2478 9.01461 31.3831 8.38667 30.3968 8.2979C29.8773 8.25187 29.3546 8.20913 28.8319 8.16968C28.9831 8.53132 29.1245 8.89954 29.2362 9.28749C29.5979 10.5237 29.7393 11.8289 29.6275 13.1144C29.302 16.8393 26.8592 20.3078 23.4598 21.8662C21.1157 22.9412 18.4362 23.1319 15.8784 22.7999C13.3206 22.4678 10.8548 21.636 8.43835 20.7352C7.12985 20.2486 5.69313 19.7522 4.33203 19.7555C5.33149 22.1325 7.4093 23.9966 10.0625 24.6147C15.6943 25.9265 21.5595 25.8245 27.6121 24.5522V24.5555Z",
    fill: "#53E50E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22474 9.53719C7.84665 9.57006 7.45542 9.60951 7.12665 9.79362C6.7946 9.97773 6.53816 10.3492 6.60391 10.7208C6.65323 10.9936 6.85706 11.2106 7.06747 11.3914C8.43186 12.5783 10.319 13.0419 12.1239 12.9432C13.9289 12.8479 15.6681 12.2397 17.3185 11.4934C17.93 11.2172 18.7453 10.6846 18.4922 9.8791C18.3179 9.32349 17.6111 9.20513 17.1113 9.16568C15.2505 9.01444 13.2976 9.20184 11.4368 9.30376C10.365 9.36294 9.29652 9.43855 8.22803 9.53061L8.22474 9.53719Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9261 29.5627C18.3311 29.5627 17.759 29.5331 17.2133 29.4772C16.3256 29.3852 15.599 28.7441 15.405 27.886C15.0894 26.5084 14.9152 25.532 14.8395 24.7232C14.7343 23.589 15.5595 22.5797 16.6839 22.4712C18.7157 22.2739 20.4253 22.2443 21.9048 22.3824C22.8746 22.4712 23.6571 23.2438 23.7656 24.2169C23.907 25.4893 23.8807 26.6564 23.6867 27.6854C23.5256 28.5534 22.8253 29.2175 21.9475 29.3391C20.8889 29.4871 19.8763 29.5594 18.9261 29.5594V29.5627ZM15.8522 24.6279C15.9245 25.3906 16.0922 26.3276 16.3946 27.6591C16.4933 28.0931 16.8648 28.4153 17.3152 28.4613C18.6533 28.6027 20.1656 28.5567 21.8061 28.3298C22.25 28.2674 22.6018 27.9353 22.684 27.498C22.8582 26.5676 22.8812 25.4991 22.7497 24.3287C22.6938 23.8323 22.2993 23.441 21.8094 23.395C20.3924 23.2635 18.7486 23.2931 16.7793 23.4838C16.2138 23.5397 15.7995 24.0493 15.8522 24.6246V24.6279Z",
    fill: "url(#paint3_linear_321_8218)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8451 20.6132C18.6731 20.3634 20.3761 20.2417 21.7503 20.4587C21.9344 20.4883 22.0758 20.6395 22.1054 20.8236C22.2533 21.708 22.204 22.8094 22.0824 23.993C22.0594 24.2099 21.8818 24.3743 21.6648 24.3809L17.2363 24.5091C17.0226 24.5157 16.8352 24.3645 16.7958 24.1541C16.5854 22.9803 16.4341 21.8823 16.467 21.0275C16.4736 20.8171 16.6347 20.6428 16.8451 20.6132ZM17.0752 28.4675C17.0391 29.628 17.1804 30.6801 17.4336 31.6664C17.4599 31.765 17.4994 31.8571 17.5585 31.9393C17.9859 32.5409 18.6303 33.0801 19.3569 33.5963C19.6232 33.787 19.9783 33.8001 20.2577 33.6259C20.9777 33.182 21.5859 32.6363 22.0627 31.9722C22.135 31.8702 22.1843 31.7519 22.204 31.627C22.3717 30.5979 22.4342 29.49 22.4144 28.3195C22.4079 27.8954 22.0791 27.5437 21.655 27.5141C20.1821 27.4121 18.8111 27.422 17.6868 27.6982C17.335 27.7837 17.0917 28.1058 17.0818 28.4675H17.0752Z",
    fill: "url(#paint4_linear_321_8218)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8494 30.2792C20.8494 30.8184 20.4154 31.1833 19.8729 31.1833C19.3305 31.1833 18.8932 30.746 18.8932 30.2036C18.8932 29.6611 19.3798 29.26 19.9189 29.26C20.4581 29.26 20.8461 29.7367 20.8461 30.2792H20.8494Z",
    fill: "url(#paint5_linear_321_8218)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_321_8218",
    x: 0.254498,
    y: 1.93335,
    width: 38.9717,
    height: 46.3601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.22634,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_321_8218"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.22634
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_321_8218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247917 0 0 0 0 0.495833 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_321_8218",
    result: "effect2_dropShadow_321_8218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_321_8218",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.403292,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_321_8218"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164174 0 0 0 0 0.391667 0 0 0 0 0.0571181 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_321_8218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_8218",
    x1: 10.2596,
    y1: -14.0815,
    x2: 21.0597,
    y2: 14.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4FF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#60E50E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_8218",
    x1: 15.7006,
    y1: -33.3771,
    x2: 21.5099,
    y2: 61.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#60E50E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_8218",
    x1: 17.8244,
    y1: -14.4335,
    x2: 20.8294,
    y2: 65.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCFF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7AE50E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_321_8218",
    x1: 19.0379,
    y1: 18.4076,
    x2: 20.7738,
    y2: 56.3803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCFF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#53E50E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_8218",
    x1: 18.4955,
    y1: -14.7721,
    x2: 19.6199,
    y2: 32.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCFF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6DE50E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_321_8218",
    x1: 19.8565,
    y1: 29.6019,
    x2: 20.3135,
    y2: 49.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6DE50E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceMenuActive);
export default __webpack_public_path__ + "static/media/marketplace-menu-active.f47442a2573e52f9598e4713a42f17f6.svg";
export { ForwardRef as ReactComponent };